// Shared mutations

import { Payload } from "vuex-pathify"

const CLEAR_IS_PUBLISHED = state => {
  if (state.model.isPublished !== undefined) {
    const p = new Payload(null, "isPublished", false)

    p.update(state.model)
  }
}

const SET_MODEL = (state, payload) => {
  if (payload instanceof Payload) {
    payload.update(state.model)
  } else {
    state.model = payload
  }

  SET_MODEL_CHANGED(state, true)
  CLEAR_IS_PUBLISHED(state)
}

const SET_MODEL_AUDIENCE = (state, payload) => {
  const model = state.model
  model.audience = payload
  state.model = model
}

const SET_MODEL_ONLY = (state, payload) => {
  if (payload instanceof Payload) {
    payload.update(state.model)
  } else {
    state.model = payload
  }
}

const SET_MODEL_CHANGED = (state, payload) => {
  const p = new Payload(null, "_changed", !!payload)

  p.update(state.model)
}

export { SET_MODEL, SET_MODEL_ONLY, SET_MODEL_CHANGED, SET_MODEL_AUDIENCE }
